// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"635":"71eef43fc11e0d53","915":"f56e32560c5f93cf"}[chunkId] + ".js";
};